import { render, staticRenderFns } from "./ChannelSettingsForm.vue?vue&type=template&id=58d0f5f6&scoped=true"
import script from "./ChannelSettingsForm.vue?vue&type=script&lang=ts"
export * from "./ChannelSettingsForm.vue?vue&type=script&lang=ts"
import style0 from "./ChannelSettingsForm.vue?vue&type=style&index=0&id=58d0f5f6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d0f5f6",
  null
  
)

export default component.exports